import { DASHBOARD_COLOR } from '../interfaces/IDashboardAnalytic';

export const DASHBOARD_THEME_COLORS = {
  SUCCESS_COLOR: process.env.REACT_APP_DASHBOARD_SUCCESS_COLOR || DASHBOARD_COLOR.GREEN,
  SUCCESS_LIGHT_COLOR: process.env.REACT_APP_DASHBOARD_SUCCESS_LIGHT_COLOR || DASHBOARD_COLOR.GREEN_LIGHT,
  DANGER_COLOR: process.env.REACT_APP_DASHBOARD_DANGER_COLOR || DASHBOARD_COLOR.RED,
  DANGER_LIGHT_COLOR: process.env.REACT_APP_DASHBOARD_DANGER_LIGHT_COLOR || DASHBOARD_COLOR.RED_EXTRA_LIGHT,
  WARNING_COLOR: process.env.REACT_APP_DASHBOARD_WARNING_COLOR || DASHBOARD_COLOR.ORANGE,
  WARNING_LIGHT_COLOR: process.env.REACT_APP_DASHBOARD_WARNING_LIGHT_COLOR || DASHBOARD_COLOR.ORANGE_LIGHT,
  COUNT_COLOR: process.env.REACT_APP_DASHBOARD_COUNT_COLOR || DASHBOARD_COLOR.BLUE,
  COUNT_LIGHT_COLOR: process.env.REACT_APP_DASHBOARD_COUNT_LIGHT_COLOR || DASHBOARD_COLOR.BLUE_LIGHT,
  // Purple — used for the "affected clients" KPI; distinct from the existing
  // red/orange/blue/green palette so the new card reads as a separate signal.
  INFO_COLOR: process.env.REACT_APP_DASHBOARD_INFO_COLOR || '#7E57C2',
  INFO_LIGHT_COLOR: process.env.REACT_APP_DASHBOARD_INFO_LIGHT_COLOR || '#D1C4E9',
} as const;
